import { UaopFlags } from '../../DryRunDialog';
import { getCurrentCountry } from '../../../../utils/countries';
import { uaopFlagDescriptionMapping } from '../../../../country/uaopFlagDescriptionMapping';
import { Categories, MetaCategories } from '../../../../country/types';

export const getTextByMetaCategoryAndFlag = (
    category: Categories,
    metaCategory: MetaCategories,
    uaopFlag: UaopFlags
) => {
    const text = uaopFlagDescriptionMapping[uaopFlag];
    const customTextPerCountry = text?.customPerCountry?.[getCurrentCountry()];
    const customTextPerMetaCategory = text?.customPerMetaCategoryAndCountry?.[metaCategory]?.[getCurrentCountry()];
    const customTextPerCategory = text?.customPerCategoryAndCountry?.[category]?.[getCurrentCountry()];

    if (!text || (!text.default && !customTextPerMetaCategory && !customTextPerCountry)) {
        throw new Error(`Missing text mapping for uaop flag: ${uaopFlag}`);
    }

    return customTextPerCategory || customTextPerMetaCategory || customTextPerCountry || text.default;
};
